<script setup lang="ts">
import { driver } from "driver.js";
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import IconComponent from "../../../../../components/ui/common/IconComponent.vue";

const props = withDefaults(
  defineProps<{
    tourSteps?: [];
    title: string | null;
    showHeader?: boolean;
    showQuickTour?: boolean;
  }>(),
  {
    showHeader: true,
    showQuickTour: true,
    showQuickView: true,
  }
);
const driverObj = driver({
  showProgress: true,
  steps: props.tourSteps,
});

const startTour = () => {
  driverObj.drive();
};
</script>

<template>
  <div class="flex max-h-[calc(100vh-7rem)]">
    <div
      class="flex-1 bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800 p-6 overflow-y-auto"
    >
      <div
        class="md:flex justify-between items-center mb-6"
        id="page-list-header"
      >
        <h2 class="text-2xl font-semibold text-gray-800 dark:text-white flex">
          <IconComponent name="Banknote" class="mr-1 mt-1" />{{ title }}
        </h2>
        <div id="page-list-header-actions" class="hidden md:flex">
          <Buttons
            caption="Quick Tour"
            v-if="showQuickTour"
            icon="BadgeHelp"
            iconColor="red"
            @click="startTour"
            id="quick-tour"
          />
          <slot name="header-actions"></slot>
        </div>
      </div>
      <slot name="main"></slot>
    </div>
  </div>
</template>
